import {take, fork, put, select} from 'redux-saga/effects';
import {push, resolveRoute, prepareSearchQueryParams} from '@computerrock/formation-router';
import {efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import routePaths from '../../routePaths';
import fetchRequest from '../../application/sagas/fetchRequest';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import * as serviceAssignmentActionTypes from '../../service-assignments/serviceAssignmentActionTypes';
import * as serviceCaseActionTypes from '../../service-cases/serviceCaseActionTypes';
import * as saspActionTypes from '../saspActionTypes';
import saspScreenTabs from '../saspScreenTabs';

const createServiceAssignmentSickPersonFlow = function* createServiceAssignmentSickPersonFlow() {
    const {serviceManager} = yield select(state => state.application);
    const ecsFlowService = serviceManager.loadService('ecsFlowService');

    while (true) {
        const {payload} = yield take(saspActionTypes.CREATE_SERVICE_ASSIGNMENT_SICK_PERSON);
        const {serviceCaseId} = payload;
        const {serviceCases = {}} = yield select(state => state.serviceCases);
        const serviceCase = serviceCases[serviceCaseId] || null;

        yield fork(
            fetchRequest,
            saspActionTypes.CREATE_SERVICE_CASE_SICK_PERSON_ASSIGNMENT_REQUEST,
            ecsFlowService.createServiceAssignment,
            {
                serviceCaseId,
                assignmentType: efServiceAssignmentTypes.SICK_PERSON,
            },
        );

        const responseAction = yield take([
            saspActionTypes.CREATE_SERVICE_CASE_SICK_PERSON_ASSIGNMENT_REQUEST_SUCCEEDED,
            saspActionTypes.CREATE_SERVICE_CASE_SICK_PERSON_ASSIGNMENT_REQUEST_FAILED,
        ]);

        // NOTE: errors are handled implicitly as part of the fetchRequest
        // below you can handle something in addition if needed

        if (!responseAction.error) {
            const {response} = responseAction.payload;
            const {serviceAssignmentDTO} = response;
            const serviceAssignmentLineNo = serviceAssignmentDTO.lineNo;

            yield put({
                type: serviceAssignmentActionTypes.STORE_SERVICE_ASSIGNMENTS,
                payload: {serviceAssignmentDTOs: [serviceAssignmentDTO]},
            });

            yield put({
                type: serviceCaseActionTypes.SET_SERVICE_CASE_ASSIGNMENTS,
                payload: {serviceAssignmentDTOs: [serviceAssignmentDTO], serviceCaseId},
            });

            // serviceAssignment.callbackPhoneNo = serviceCase.callbackPhoneNo, by default
            if (serviceCase?.callbackPhoneNo) {
                yield* updateServiceAssignment({
                    caller: saspActionTypes.CREATE_SERVICE_ASSIGNMENT_SICK_PERSON,
                    assignmentType: efServiceAssignmentTypes.SICK_PERSON,
                    serviceAssignmentLineNo,
                    serviceCaseId,
                    serviceAssignmentData: {
                        callbackPhoneNo: serviceCase.callbackPhoneNo,
                    },
                });
            }

            yield put(push(resolveRoute(
                routePaths.SERVICE_ASSIGNMENT_SICK_PERSON,
                {
                    serviceCaseId,
                    serviceAssignmentLineNo,
                },
                {search: prepareSearchQueryParams({activeTab: saspScreenTabs.SERVICE_PROVIDER})},
            )));
        }
    }
};
export default createServiceAssignmentSickPersonFlow;
